import enMfe from './en/mfe.json';
import esMfe from './es-MX/mfe.json';

export const mfeTranslations = {
  en: enMfe,
  'es-MX': esMfe,
};

export { registerMfeTranslations } from './registerTranslations';
